import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../services/api.service';

/**
 * Modification d'un destinataire (PUT /addresses/:id)
 */
export default function useUpdateAddress() {
  const [isLoading, setIsLoading] = useState(false);

  const updateAddress = async (addressId, addressData) => {
    try {
      setIsLoading(true);
      const response = await fleetApi.put(
        `/addresses/${addressId}`,
        addressData
      );
      toast.success('Destinataire modifié avec succès.');
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, updateAddress };
}
